<template>
  <div>
    <div v-if="type==1">
      <!-- 头部 -->
      <div v-show="!isWeixin" class="head">
        <img class="img_arrow" src="@/assets/test/return.png" alt @click="goBack()">
        <p class="my_title">问答列表</p>
        <span></span>
      </div>
      <!-- 小程序头部 -->
      <div v-show="isWeixin" class="wechatHead">
        <!-- <div class="wechatHead"> -->
        <div class="iptbox" @click="showpopup()">
          <div class="iptboxdiv">
            <img class="logo" src="@/assets/myicon/logo.png" alt="">
            <p>{{ lesson_name }}</p>
          </div>

          <img class="bottomArrow" src="@/assets/myicon/xiala.png" alt="">
        </div>
      </div>
      <!-- 回到顶部 -->
      <div class="goTop">
        <img v-show="is_buy!=0&&loadIsBuy" src="@/assets/myicon/subm.png" alt="" @click="submit()">
        <a href="#here"><img src="@/assets/myicon/gotop.png" alt="" @click="go_top()"></a>
      </div>
      <div style="clear:both;"></div>
      <div v-if="is_buy != 0&&loadIsBuy" class="qa_main">
        <!-- tab栏 -->
        <div class="mytab">
          <div class="mytab_content">
            <p
              v-for="(item, index) in tab_list"
              :key="index"
              class="tabp"
              :class="{ redBottom: active == index }"
              @click="checkedMyTab(index)"
            >
              <span class="tabmsg" :class="{ redBottomspan: active == index }">{{ item.title }}</span>
              <span v-show="item.title == '我的提问'&&subnum!=0&&subnum!=''&&subnum>0" class="moreNum">{{ subnum }}</span>
              <!-- <span class="moreNum">99</span> -->
            </p>
          </div>
        </div>

        <!-- tab -->
        <!--  @refresh="onRefresh" -->
        <!-- <van-pull-refresh v-model="isLoading"> -->
        <div class="tablist">
          <!-- 第一个tab -->
          <van-list
            v-show="isShow&&active == 0"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="activeDIV">
              <div id="here"></div>

              <div v-for="(item,index) in QaList" :key="index">
                <!-- 问题 -->
                <div class="QaDiv">
                  <div class="QaDivleft">
                    <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item.avatar" alt="">
                  </div>
                  <div class="QaDivright">
                    <p class="qaname">{{ item.username }}</p>
                    <p v-show="item.extra" class="qalesson">{{ item.extra }}</p>
                    <p class="qacontent" v-html="item.content"></p>
                    <div class="replyImgs">
                      <div v-for="(itemimg,indeximg) in item.images?item.images.slice(0,3):[]" :key="indeximg" class="moreImg" @click="changeIndex(indeximg,item.images)">
                        <div v-show="indeximg == 2&&item.images.length>3" class="grayAdd">
                          <p>+{{ item.images.length-3 }}</p>
                        </div>
                        <!-- <img :src="itemimg" alt=""> -->
                        <div class="imgbackg" :style="'background-image:url('+itemimg+')'">

                        </div>
                      </div>
                    </div>
                    <p class="qatime">
                      {{ item.create_time }}
                      <span class="RedHuiFu" @click="replyQA(item,index)"> 回复</span>
                      <span v-if="item.is_edit" class="tv_huifu" @click="ediWd(item,true,index,-1)">编辑</span>
                      <span v-if="is_teacher==1 || item.is_edit" @click="delhf(item.id,QaList,index)">删除</span>
                    </p>
                  </div>
                </div>
                <!-- 回复 -->
                <div v-for="(item1,index1) in item.list" :key="index1" class="reply">
                  <div class="replyQaDivleft">
                    <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item1.avatar" alt="">
                  </div>
                  <div class="replyQaDivright">
                    <p class="replyqaname"><span :class="{redspan:item1.user_type==1,bluespan:item1.user_type==2}">{{ item1.username }}</span> <span class="replytest">回复</span> <span :class="{redspan:item1.to_user_type==1,bluespan:item1.to_user_type==2}">{{ item1.to_username }}</span></p>
                    <p class="replyqacontent" v-html="item1.content"></p>
                    <div class="replyImgs">
                      <div v-for="(item2,index2) in item1.images?item1.images.slice(0,3):[]" :key="index2" class="moreImg" @click="changeIndex(index2,item1.images)">
                        <div v-show="index2 == 2&&item1.images.length>3" class="grayAdd">
                          <p>+{{ item1.images.length-3 }}</p>
                        </div>
                        <div class="imgbackg" :style="'background-image:url('+item2+')'">

                        </div>
                        <!-- <img :src="item2" alt=""> -->
                      </div>
                    </div>
                    <p class="replyqatime">
                      {{ item1.create_time }}
                      <span class="RedHuiFu" @click="replyReply(item1,index)"> 回复</span>
                      <span v-if="item1.is_edit" class="tv_huifu" @click="ediWd(item1,false,index,index1)">编辑</span>
                      <span v-show="is_teacher==1 || item1.is_edit" class="qatime" @click="delhf(item1.id,item.list,index1,item)">删除</span>
                    </p>

                    <div v-if="item.count>1&&item.count>=(item.page*3)-1" class="openReply" @click="seeMores(item.id,index,item.page,item.count,item.list)">
                      <p v-show="item.list!==[]&&index1 == item.list.length-1" class="replyqatime">{{ item.replyMsg }}</p>
                      <img v-show="item.list!==[]&&index1 == item.list.length-1" src="@/assets/myicon/bottomarrow.png" alt="">
                    </div>
                    <div v-else class="openReply" @click="PutAway(index)">
                      <p v-show="item.count>1&&item.list!==[]&&index1 == item.list.length-1" class="replyqatime">收起</p>
                      <img v-show="item.count>1&&item.list!==[]&&index1 == item.list.length-1" src="@/assets/myicon/toparrow.png" alt="">
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.count > 1 && item.list.length==0"
                  class="openReply div_sq"
                  @click="seeMores(item.id,index,item.page,item.count,item.list)"
                >
                  <p class="replyqatime">
                    {{ item.replyMsg }}
                  </p>
                  <img src="@/assets/myicon/bottomarrow.png" alt="">
                </div>
              </div>
            </div>
          </van-list>
          <div v-show="active == 0&&!QaList.length" class="nodatas">
            <img src="@/assets/new_kong.png" alt="kong">
            <p>暂时还没有相关问答~</p>
          </div>
          <!-- 第二个tab -->
          <van-list
            v-show="isShow1&&active == 1"
            v-model="loading1"
            :finished="finished1"
            finished-text="没有更多了"
            @load="onLoad1"
          >
            <div class="activeDIV">
              <div v-for="(item,index) in myQaList" :key="index">
                <!-- 问题 -->
                <div class="QaDiv">
                  <div class="QaDivleft">
                    <div class="avatars">
                      <div v-show="item.have_read==0" class="haveread">

                      </div>
                      <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item.avatar" alt="">
                    </div>

                  </div>
                  <div class="QaDivright">
                    <p class="qaname">{{ item.username }}</p>
                    <p class="qalesson">{{ item.extra }}</p>
                    <p class="qacontent" v-html="item.content"></p>
                    <div class="replyImgs">
                      <div v-for="(itemimg,indeximg) in item.images?item.images.slice(0,3):[]" :key="indeximg" class="moreImg" @click="changeIndex(indeximg,item.images)">
                        <div v-show="indeximg == 2&&item.images.length>3" class="grayAdd">
                          <p>+{{ item.images.length-3 }}</p>
                        </div>
                        <div class="imgbackg" :style="'background-image:url('+itemimg+')'">

                        </div>
                      </div>
                    </div>
                    <p class="qatime">
                      {{ item.create_time }}
                      <span class="RedHuiFu" @click="replyQA(item,index)"> 回复</span>
                      <span v-if="item.is_edit" class="tv_huifu" @click="ediWd(item,true,index,-1)">编辑</span>
                      <span v-if="is_teacher==1 || item.is_edit" @click="delhf(item.id,myQaList,index)">删除</span>
                    </p>

                  </div>
                </div>
                <!-- 回复 -->
                <div v-for="(item1,index1) in item.list" :key="index1" class="reply">
                  <div class="replyQaDivleft">
                    <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item1.avatar" alt="">
                  </div>
                  <div class="replyQaDivright">
                    <p class="replyqaname"><span :class="{redspan:item1.user_type==1,bluespan:item1.user_type==2}">{{ item1.username }}</span> <span class="replytest">回复</span> <span :class="{redspan:item1.to_user_type==1,bluespan:item1.to_user_type==2}">{{ item1.to_username }}</span></p>
                    <p class="replyqacontent" v-html="item1.content"></p>
                    <div class="replyImgs">
                      <div v-for="(item2,index2) in item1.images?item1.images.slice(0,3):[]" :key="index2" class="moreImg" @click="changeIndex(index2,item1.images)">
                        <div v-show="index2 == 2&&item1.images.length>3" class="grayAdd">
                          <p>+{{ item1.images.length-3 }}</p>
                        </div>
                        <div class="imgbackg" :style="'background-image:url('+item2+')'">

                        </div>
                      </div>
                    </div>
                    <p class="replyqatime">
                      {{ item1.create_time }}
                      <span class="RedHuiFu" @click="replyReply(item1,index)"> 回复</span>
                      <span v-if="item1.is_edit" class="tv_huifu" @click="ediWd(item1,false,index,index1)">编辑</span>
                      <span v-show="is_teacher==1 || item1.is_edit" class="qatime" @click="delhf(item1.id,item.list,index1,item)">删除</span>
                    </p>
                    <div v-if="item.count>1&&item.count>=(item.page*3)-1" class="openReply" @click="seeMoresMyQA(item.id,index,item.page,item.count,item.list)">
                      <p v-show="item.list!==[]&&index1 == item.list.length-1" class="replyqatime">{{ item.replyMsg }}</p>
                      <img v-show="item.list!==[]&&index1 == item.list.length-1" src="@/assets/myicon/bottomarrow.png" alt="">
                    </div>
                    <div v-else class="openReply" @click="PutAwayMyQA(index)">
                      <p v-show="item.count>1&&item.list!==[]&&index1 == item.list.length-1" class="replyqatime">收起</p>
                      <img v-show="item.count>1&&item.list!==[]&&index1 == item.list.length-1" src="@/assets/myicon/toparrow.png" alt="">
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.count > 1 && item.list.length==0"
                  class="openReply div_sq"
                  @click="seeMoresMyQA(item.id,index,item.page,item.count,item.list)"
                >
                  <p class="replyqatime">
                    {{ item.replyMsg }}
                  </p>
                  <img src="@/assets/myicon/bottomarrow.png" alt="">
                </div>
              </div>
            </div>
          </van-list>
          <div v-show="active == 1&&!myQaList.length" class="nodatas">
            <img src="@/assets/new_kong.png" alt="kong">
            <p>暂时还没有相关问答~</p>
          </div>
          <!-- 第三个tab -->
          <van-list
            v-show="isShow2&&active == 2"
            v-model="loading2"
            :finished="finished2"
            finished-text="没有更多了"
            @load="onLoad2"
          >
            <div class="activeDIV">
              <div v-for="(item,index) in replyQaList" :key="index">
                <!-- 问题 -->
                <div class="QaDiv">
                  <div class="QaDivleft">
                    <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item.avatar" alt="">
                  </div>
                  <div class="QaDivright">
                    <p class="qaname">{{ item.username }}</p>
                    <p class="qalesson">{{ item.extra }}</p>
                    <p class="qacontent" v-html="item.content"></p>
                    <div class="replyImgs">
                      <div v-for="(itemimg,indeximg) in item.images?item.images.slice(0,3):[]" :key="indeximg" class="moreImg" @click="changeIndex(indeximg,item.images)">
                        <div v-show="indeximg == 2&&item.images.length>3" class="grayAdd">
                          <p>+{{ item.images.length-3 }}</p>
                        </div>
                        <div class="imgbackg" :style="'background-image:url('+itemimg+')'">

                        </div>
                      </div>
                    </div>
                    <p class="qatime">
                      {{ item.create_time }}
                      <span class="RedHuiFu" @click="replyQA(item,index)"> 回复</span>
                      <span v-if="item.is_edit" class="tv_huifu" @click="ediWd(item,true,index,-1)">编辑</span>
                      <span v-if="is_teacher==1 || item.is_edit" @click="delhf(item.id,replyQaList,index)">删除</span>
                    </p>

                  </div>
                </div>
                <!-- 回复 -->
                <div v-for="(item1,index1) in item.list" :key="index1" class="reply">
                  <div class="replyQaDivleft">
                    <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item1.avatar" alt="">
                  </div>
                  <div class="replyQaDivright">
                    <p class="replyqaname"><span :class="{redspan:item1.user_type==1,bluespan:item1.user_type==2}">{{ item1.username }}</span> <span class="replytest">回复</span> <span :class="{redspan:item1.to_user_type==1,bluespan:item1.to_user_type==2}">{{ item1.to_username }}</span></p>
                    <p class="replyqacontent" v-html="item1.content"></p>
                    <div class="replyImgs">
                      <div v-for="(item2,index2) in item1.images?item1.images.slice(0,3):[]" :key="index2" class="moreImg" @click="changeIndex(index2,item1.images)">
                        <div v-show="index2 == 2&&item1.images.length>3" class="grayAdd">
                          <p>+{{ item1.images.length-3 }}</p>
                        </div>
                        <div class="imgbackg" :style="'background-image:url('+item2+')'">

                        </div>
                      </div>
                    </div>
                    <p class="replyqatime">
                      {{ item1.create_time }}
                      <span class="RedHuiFu" @click="replyReply(item1,index)"> 回复</span>
                      <span v-if="item1.is_edit" class="tv_huifu" @click="ediWd(item1,false,index,index1)">编辑</span>
                      <span v-show="is_teacher==1 || item1.is_edit" class="qatime" @click="delhf(item1.id,item.list,index1,item)">删除</span>
                    </p>

                    <div v-if="item.count>1&&item.count>=(item.page*3)-1" class="openReply" @click="seeMoresMyQ(item.id,index,item.page,item.count,item.list)">
                      <p v-show="item.list!==[]&&index1 == item.list.length-1" class="replyqatime">{{ item.replyMsg }}</p>
                      <img v-show="item.list!==[]&&index1 == item.list.length-1" src="@/assets/myicon/bottomarrow.png" alt="">
                    </div>
                    <div v-else class="openReply" @click="PutAwayMyQ(index)">
                      <p v-show="item.count>1&&item.list!==[]&&index1 == item.list.length-1" class="replyqatime">收起</p>
                      <img v-show="item.count>1&&item.list!==[]&&index1 == item.list.length-1" src="@/assets/myicon/toparrow.png" alt="">
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.count > 1 && item.list.length==0"
                  class="openReply div_sq"
                  @click="seeMoresMyQ(item.id,index,item.page,item.count,item.list)"
                >
                  <p class="replyqatime">
                    {{ item.replyMsg }}
                  </p>
                  <img src="@/assets/myicon/bottomarrow.png" alt="">
                </div>
              </div>
            </div>
          </van-list>
          <div v-show="active == 2&&!replyQaList.length" class="nodatas">
            <img src="@/assets/new_kong.png" alt="kong">
            <p>暂时还没有相关问答~</p>
          </div>
        </div>
        <!-- </van-pull-refresh> -->
      </div>
      <!-- 未购买页面 -->
      <div v-else class="noIsBuy">
        <van-list
          v-show="QaList.length"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div v-for="(item,index) in QaList" :key="index">
            <!-- 问题 -->
            <div class="QaDiv">
              <div class="QaDivleft">
                <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item.avatar" alt="">
              </div>
              <div class="QaDivright">
                <p class="qaname">{{ item.username }}</p>
                <p class="qalesson">{{ item.extra }}</p>
                <p class="qacontent" v-html="item.content"></p>
                <div class="replyImgs">
                  <div v-for="(itemimg,indeximg) in item.images?item.images.slice(0,3):[]" :key="indeximg" class="moreImg" @click="changeIndex(indeximg,item.images)">
                    <div v-show="indeximg == 2&&item.images.length>3" class="grayAdd">
                      <p>+{{ item.images.length-3 }}</p>
                    </div>
                    <div class="imgbackg" :style="'background-image:url('+itemimg+')'">

                    </div>
                  </div>
                </div>
                <p class="qatime">
                  {{ item.create_time }}
                  <!-- <span class="RedHuiFu" @click="replyQA(item,index)"> 回复</span>
                  <span v-if="item.is_edit" class="tv_huifu" @click="ediWd(item,true,index,-1)">编辑</span>
                  <span v-if="is_teacher==1 || item.is_edit" @click="delhf(item.id,QaList,index)">删除</span> -->
                </p>
              </div>
            </div>
            <!-- 回复 -->
            <div v-for="(item1,index1) in item.list" :key="index1" class="reply">
              <div class="replyQaDivleft">
                <img  onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item1.avatar" alt="">
              </div>
              <div class="replyQaDivright">
                <p class="replyqaname"><span :class="{redspan:item1.user_type==1,bluespan:item1.user_type==2}">{{ item1.username }}</span> <span class="replytest">回复</span> <span :class="{redspan:item1.to_user_type==1,bluespan:item1.to_user_type==2}">{{ item1.to_username }}</span></p>
                <p class="replyqacontent" v-html="item1.content"></p>
                <div class="replyImgs">
                  <div v-for="(item2,index2) in item1.images?item1.images.slice(0,3):[]" :key="index2" class="moreImg" @click="changeIndex(index2,item1.images)">
                    <div v-show="index2 == 2&&item1.images.length>3" class="grayAdd">
                      <p>+{{ item1.images.length-3 }}</p>
                    </div>
                    <div class="imgbackg" :style="'background-image:url('+item2+')'">

                    </div>
                  </div>
                </div>
                <p class="replyqatime">
                  {{ item1.create_time }}
                  <!-- <span class="RedHuiFu" @click="replyReply(item1,index)"> 回复</span>
                  <span v-if="item1.is_edit" class="tv_huifu" @click="ediWd(item1,false,index,index1)">编辑</span>
                  <span v-show="is_teacher==1 || item1.is_edit" class="qatime" @click="delhf(item1.id,item.list,index1,item)">删除</span> -->
                </p>

                <div v-if="item.count>1&&item.count>=(item.page*3)-1" class="openReply" @click="seeMores(item.id,index,item.page,item.count,item.list)">
                  <p v-show="item.list!==[]&&index1 == item.list.length-1" class="replyqatime">{{ item.replyMsg }}</p>
                  <img v-show="item.list!==[]&&index1 == item.list.length-1" src="@/assets/myicon/bottomarrow.png" alt="">
                </div>
                <div v-else class="openReply" @click="PutAway(index)">
                  <p v-show="item.count>1&&item.list!==[]&&index1 == item.list.length-1" class="replyqatime">收起</p>
                  <img v-show="item.count>1&&item.list!==[]&&index1 == item.list.length-1" src="@/assets/myicon/toparrow.png" alt="">
                </div>
              </div>
            </div>
            <div
              v-if="item.count > 1 && item.list.length==0"
              class="openReply div_sq"
              @click="seeMores(item.id,index,item.page,item.count,item.list)"
            >
              <p class="replyqatime">
                {{ item.replyMsg }}
              </p>
              <img src="@/assets/myicon/bottomarrow.png" alt="">
            </div>
          </div>
        </van-list>
        <div v-show="!QaList.length" class="nodatas">
          <img src="@/assets/new_kong.png" alt="kong">
          <p>暂时还没有相关问答~</p>
        </div>
      </div>

    </div>
    <!-- 回复页面 -->
    <div v-else>
      <replypage ref="headerChild" :msg="replyQAobj" @childFn="parentFn" @childFns="parentFns"></replypage>
    </div>
    <!-- 小程序弹出框 -->
    <div>
      <van-popup v-model="wechatshow" position="bottom" :style="{ height: '100%' }">
        <p class="popuptitle">请选择课程</p>
        <div v-for="(item,index) in havelesson" :key="index" class="popupbox" :class="{popupboxred:lessonActive==index}" @click="changeList(item.lesson_id,index,item.lesson_shortname)">
          {{ item.lesson_shortname }}
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import { QaAll, Qame, Qamyreply, buylist, seeMore, changeStatus, delQa, getIsBuy } from '@/api/course.js'
import replypage from '@/components/QA/reply.vue'
import isWeixin from '@/utils/isWechat.js'
import wx from 'weixin-js-sdk'
import Cookies from 'js-cookie'
import { Toast } from 'vant'

export default {
  components: {
    replypage,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {
      uid: '',
      is_teacher: 0,
      onePage: 1,
      twoPage: 1,
      threePage: 1,
      isShow: true,
      loading: false,
      finished: false,
      retlen: 0,
      total: 0,
      isShow1: true,
      loading1: false,
      finished1: false,
      total1: 0,
      retlen1: 0,
      isShow2: true,
      loading2: false,
      finished2: false,
      total2: 0,
      retlen2: 0,
      isShow3: true,
      loading3: false,
      finished3: false,
      total3: 0,
      retlen3: 0,
      lesson_name: '请选择课程',
      lessonActive: 0,
      lesson_id: 0,
      havelesson: [],
      wechatshow: false,
      type: 1,
      replyList: [1],
      images: [],
      tab_list: [
        { title: '全部问答' },
        { title: '我的提问' },
        { title: '我的回答' }
      ],
      active: 0,
      subnum: '',
      QaList: [],
      page: 1,
      page1: 1,
      page2: 1,
      isWeixin: false,
      myQaList: [],
      replyQaList: [],
      strMap: {},
      replyQAobj: {},
      limit: 10,
      limit1: 10,
      limit2: 10,
      QaCount: '',
      myQaCount: '',
      replyQaCount: '',
      isLoading: false,
      is_buy: 0,
      loadIsBuy: false,
      biaoList: ['男-惊讶', '男-流泪', '男-害羞', '男-闭嘴', '男-睡', '男-发怒', '男-得意', '男-抓狂', '男-吐', '男-偷笑', '男-困', '男-流汗', '男-咒骂', '男-疑问', '男-嘘', '男-晕', '男-衰', '男-再见', '男-猪头', '男-拥抱', '男-爱心', '男-心碎', '男-强', '男-弱', '男-抠鼻', '男-鼓掌', '男-左哼哼', '男-右哼哼', '男-哈欠', '男-鄙视', '男-委屈', '男-阴险', '男-亲亲', '男-可怜', '男-勾引', '男-NO', '男-OK', '男-爱你', '男-蛋糕', '男-给力', '男-哈哈', '男-大哈哈', '男-蜡烛', '男-礼物', '男-胜利']
    }
  },
  watch: {
    active(n, old) {
      if (old === 1) {
        var params = {
          lesson_id: sessionStorage.getItem('lessonId')
        }
        changeStatus(params).then(res => {
          this.page1 = 1
          this.onLoad1()
        })
      }
    }
  },
  created() {
    this.getIsBuyFun()
    const lessonId = this.$route.query.lesson_id
    if (lessonId) {
      sessionStorage.setItem('lessonId', lessonId)
    }
    this.lesson_id = sessionStorage.getItem('lessonId')
    this.lesson_name = sessionStorage.getItem('lessonName')
    // this.onLoad2()
    // this.onLoad1()
    // this.onLoad()
    this.is_buyLseeon()
    

    document.title = '课程问答'
  },
  mounted() {
    this.uid = Cookies.get('uid')
    document.title = '课程问答'
    wx.miniProgram.postMessage({ data: { title: '请选择课程' }})
    // if (this.$route.query.lesson_name) {
    //   this.lesson_name = this.$route.query.lesson_name
    // }
    this.isWeixin = isWeixin
    if (!this.isWeixin) {
      if (document.getElementsByClassName('mytab')[0]) {
        document.getElementsByClassName('mytab')[0].style.marginTop = '44px'
        document.getElementsByClassName('mytab')[0].style.position = 'fixed'
        document.getElementsByClassName('mytab')[0].style.top = '2px'
        document.getElementsByClassName('mytab')[0].style.zIndex = '999'
      }
      if (document.getElementsByClassName('activeDIV')[0]) {
        document.getElementsByClassName('activeDIV')[0].style.marginTop = '107PX'
        document.getElementsByClassName('activeDIV')[1].style.marginTop = '107PX'
        document.getElementsByClassName('activeDIV')[2].style.marginTop = '107PX'
      }
    } else {
      if (document.getElementsByClassName('wechatHead')[0]) {
        document.getElementsByClassName('wechatHead')[0].style.position = 'fixed'
        document.getElementsByClassName('wechatHead')[0].style.top = '0px'
        document.getElementsByClassName('wechatHead')[0].style.zIndex = '999'
      }
      if (document.getElementsByClassName('mytab')[0]) {
        document.getElementsByClassName('mytab')[0].style.position = 'fixed'
        document.getElementsByClassName('mytab')[0].style.top = '40px'
        document.getElementsByClassName('mytab')[0].style.zIndex = '999'
      }
      if (document.getElementsByClassName('activeDIV')[0]) {
        document.getElementsByClassName('activeDIV')[0].style.marginTop = '107PX'
        document.getElementsByClassName('activeDIV')[1].style.marginTop = '107PX'
        document.getElementsByClassName('activeDIV')[2].style.marginTop = '107PX'
      }
    }
    this.biaoList.forEach((item, index) => {
      if (index < 9) {
        this.strMap[index] = '<img src=' + require('@/assets/lan/0' + (index + 1) + '.gif') + '>'
      } else {
        this.strMap[index] = '<img src=' + require('@/assets/lan/' + (index + 1) + '.gif') + '>'
      }
    })
  },
  methods: {
    // 判断课程是否购买
    getIsBuyFun() {
      var info = {
        lesson_id: this.lesson_id
      }
      getIsBuy(info).then((res) => {
        this.is_buy = res
      }).then(() => {
        this.loadIsBuy = true
        if (this.is_buy == 0) {
          this.onLoad()
        }
      })
    },
    // 删除回复
    delhf(id, list, index, parent) {
      delQa({ id, operate: 5 }).then((res) => {
        if (parent) {
          const count1 = parent.count - 1
          this.$set(parent, 'count', count1)
        }
        list.splice(index, 1)
        this.$forceUpdate()
      })
    },
    // 下拉刷新
    async onRefresh() {
      this.page = 1
      this.page1 = 1
      this.page2 = 1
      await this.onLoad2()
      await this.onLoad1()
      await this.onLoad()
      await this.is_buyLseeon()
      this.isLoading = false
    },
    PutAway(index) {
      this.QaList[index].list = this.QaList[index].list.slice(0, 1)
      this.$set(this.QaList[index], 'page', 1)
      this.$set(this.QaList[index], 'replyMsg', `展开${this.QaList[index].count - 1}条回复`)
      this.$forceUpdate()
    },
    PutAwayMyQA(index) {
      this.myQaList[index].list = this.myQaList[index].list.slice(0, 1)
      this.$set(this.myQaList[index], 'page', 1)
      this.$set(this.myQaList[index], 'replyMsg', `展开${this.myQaList[index].count - 1}条回复`)
      this.$forceUpdate()
    },
    seeMores(id, index, page, counts, num) {
      var params = {
        page: page,
        limit: 3,
        question_id: id
      }
      seeMore(params).then(res => {
        if (res.errNo === 0) {
          var reg = /{([\s\S]*?)}/g
          var _this = this
          res.result.list.forEach((item) => {
            if (item.content) {
              item.content_before = item.content
              item.content = item.content.replace(reg, function(str) {
                str = str.split('{')[1].split('}')[0]
                var strMap = _this.strMap
                // console.log(str, 'str')
                if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                  return strMap[0]
                } else {
                  return strMap[_this.biaoList.indexOf(str)]
                }
              })
            }
          })
          if (res.result.list != []) {
            console.log(this.QaList[index].list)
            this.QaList[index].list.push(...res.result.list)
            this.$set(this.QaList[index], 'page', this.QaList[index].page + 1)
            console.log(counts, num)
            this.$set(this.QaList[index], 'replyMsg', `展开${counts - num.length}条回复`)
          }
        }
        this.$forceUpdate()
      })
    },
    PutAwayMyQ(index) {
      this.replyQaList[index].list = this.replyQaList[index].list.slice(0, 1)
      this.$set(this.replyQaList[index], 'page', 1)
      this.$set(this.replyQaList[index], 'replyMsg', `展开${this.replyQaList[index].count - 1}条回复`)
      this.$forceUpdate()
    },
    seeMoresMyQ(id, index, page, counts, num) {
      var params = {
        page: page,
        limit: 3,
        question_id: id
      }
      seeMore(params).then(res => {
        if (res.errNo === 0) {
          var reg = /{([\s\S]*?)}/g
          var _this = this
          res.result.list.forEach((item) => {
            if (item.content) {
              item.content_before = item.content
              item.content = item.content.replace(reg, function(str) {
                str = str.split('{')[1].split('}')[0]
                var strMap = _this.strMap
                // console.log(str, 'str')
                if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                  return strMap[0]
                } else {
                  return strMap[_this.biaoList.indexOf(str)]
                }
              })
            }
          })
          if (res.result.list != []) {
            console.log(this.replyQaList[index].list)
            this.replyQaList[index].list.push(...res.result.list)
            this.$set(this.replyQaList[index], 'page', this.replyQaList[index].page + 1)

            console.log(counts, num)
            this.$set(this.replyQaList[index], 'replyMsg', `展开${counts - num.length}条回复`)
          }
        }
        this.$forceUpdate()
      })
    },
    seeMoresMyQA(id, index, page, counts, num) {
      var params = {
        page: page,
        limit: 3,
        question_id: id
      }
      seeMore(params).then(res => {
        if (res.errNo === 0) {
          var reg = /{([\s\S]*?)}/g
          var _this = this
          res.result.list.forEach((item) => {
            if (item.content) {
              item.content_before = item.content
              item.content = item.content.replace(reg, function(str) {
                str = str.split('{')[1].split('}')[0]
                var strMap = _this.strMap
                // console.log(str, 'str')
                if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                  return strMap[0]
                } else {
                  return strMap[_this.biaoList.indexOf(str)]
                }
              })
            }
          })
          if (res.result.list != []) {
            console.log(this.myQaList[index].list)
            this.myQaList[index].list.push(...res.result.list)
            this.$set(this.myQaList[index], 'page', this.myQaList[index].page + 1)

            console.log(counts, num)
            this.$set(this.myQaList[index], 'replyMsg', `展开${counts - num.length}条回复`)
          }
        }
        this.$forceUpdate()
      })
    },
    changeList(id, index, n) {
      this.QaList = []
      this.myQaList = []
      this.replyQaList = []
      this.page2 = 1
      this.page1 = 1
      this.page = 1
      this.lessonActive = index
      this.lesson_id = id
      this.lesson_name = n
      sessionStorage.setItem('lessonName', n)
      sessionStorage.setItem('lessonId', id)
      setTimeout(() => {
        this.onLoad()
        this.onLoad2()
        this.onLoad1()
        this.wechatshow = false
      }, 700)
    },
    is_buyLseeon() {
      var params = {
        type: 2,
        lesson_id: this.lesson_id
      }
      buylist(params).then(res => {
        this.havelesson = res.result.list
      })
    },
    showpopup() {
      this.wechatshow = true
    },
    // 回到顶部
    go_top() {
      // alert(document.getElementsByClassName('tablist')[0].scrollTop)
      document.documentElement.scrollTop = 0
    },
    parentFns(v) {
      this.styleChange()
      console.log(v, 'v')
      var _this = this
      var reg = /{([\s\S]*?)}/g
      v.content = v.content.replace(reg, function(str) {
        str = str.split('{')[1].split('}')[0]
        var strMap = _this.strMap
        // console.log(str, 'str')
        if (strMap[_this.biaoList.indexOf(str)] === undefined) {
          return strMap[0]
        } else {
          return strMap[_this.biaoList.indexOf(str)]
        }
      })
      console.log(v.sendtype)
      if (v.sendtype == 1) {
        this.updateItem(this.QaList, v)
      } else if (v.sendtype == 2) {
        this.updateItem(this.myQaList, v)
      } else if (v.sendtype == 3) {
        this.updateItem(this.replyQaList, v)
      }
    },
    updateItem(data, upItem) {
      if (upItem.isEdiWd) {
        if (upItem.isParent) {
          const list = data[upItem.p_index].list
          upItem.list = list
          data[upItem.p_index] = upItem
        } else {
          data[upItem.p_index].list[upItem.s_index] = upItem
        }
      } else {
        data[upItem.p_index].count++
        data[upItem.p_index].replyMsg = `展开${data[upItem.p_index].count - 1}条回复`
        data[upItem.p_index].list = []
        data[upItem.p_index].list.unshift(upItem)
      }
    },
    parentFn(payload) {
      this.styleChange()
      console.log(payload, 'payload')
      setTimeout(() => {
        document.documentElement.scrollTop = payload
        document.body.scrollTop = payload
      }, 50)
    },
    // 回复问答
    replyQA(item, p_index) {
      if (this.isBuy == 0 && this.is_teacher == 0) {
        Toast('请先加入学习')
        return
      }
      var sendtype
      if (this.active == 0) {
        sendtype = 1
      } else if (this.active == 1) {
        sendtype = 2
      } else if (this.active == 2) {
        sendtype = 3
      }
      this.replyQAobj = {
        lesson_id: this.lesson_id,
        parent_id: item.id,
        question_id: item.id,
        to_username: item.username,
        p_index: p_index,
        scrollTop: document.documentElement.scrollTop,
        to_user_type: item.user_type,
        username: item.username,
        active: this.active,
        to_uid: item.uid,
        sendtype: sendtype

      }
      this.type = 2
      document.documentElement.scrollTop = 0
    },
    ediWd(item1, isParent, p_index, s_index) {
      this.isEdiWd = true
      console.log(JSON.stringify(item1) + '-------------------ediWd----------------')
      if (this.isBuy == 0 && this.is_teacher == 0) {
        Toast('请先加入学习')
        return
      }
      var sendtype
      if (this.active == 0) {
        sendtype = 1
      } else if (this.active == 1) {
        sendtype = 2
      } else if (this.active == 2) {
        sendtype = 3
      }
      const fileList = []
      console.log(item1.images + '870-----------')
      for (let i = 0; i < item1.images.length; i++) {
        fileList.push({ url: item1.images[i], uid: fileList.length })
      }
      this.replyQAobj = {
        lesson_id: this.lesson_id,
        parent_id: item1.id ? item1.id : item1.parent_id,
        id: item1.id,
        fileList: fileList,
        question_id: item1.question_id,
        to_username: item1.username,
        scrollTop: document.documentElement.scrollTop,
        to_user_type: item1.user_type,
        username: item1.username,
        content_before: item1.content_before,
        count: item1.count,
        page: item1.page,
        replyMsg: item1.replyMsg,
        active: this.active,
        isParent: isParent,
        p_index: p_index,
        s_index: s_index,
        isEdiWd: true,
        to_uid: item1.uid,
        sendtype: sendtype
      }
      /* if (isParent) {
        this.dialog_title = '编辑问答'
      } else {
        this.dialog_title = '编辑回复'
      }*/
      // 回复页面类型
      this.type = 2
    },
    // 回复回复
    replyReply(item1, p_index) {
      this.isEdiWd = false

      if (this.isBuy == 0 && this.is_teacher == 0) {
        Toast('请先加入学习')
        return
      }
      var sendtype
      if (this.active == 0) {
        sendtype = 1
      } else if (this.active == 1) {
        sendtype = 2
      } else if (this.active == 2) {
        sendtype = 3
      }
      this.replyQAobj = {
        lesson_id: this.lesson_id,
        parent_id: item1.id ? item1.id : item1.parent_id,
        question_id: item1.question_id,
        to_username: item1.username,
        scrollTop: document.documentElement.scrollTop,
        p_index: p_index,
        to_user_type: item1.user_type,
        username: item1.username,
        active: this.active,
        to_uid: item1.uid,
        sendtype: sendtype
      }
      this.type = 2
      document.documentElement.scrollTop = 0
    },
    // 问答列表
    onLoad() {
      var params = {
        page: this.page,
        limit: this.limit,
        lesson_id: this.lesson_id
      }
      var _this = this

      QaAll(params).then(res => {
        if (res.errNo === 0) {
          res.result.list.forEach(e => {
            this.$set(e, 'page', 1)
            this.$set(e, 'replyMsg', `展开${e.count - 1}条回复`)
          })
          if (!res.result.list.length && !this.QaList.length) {
          // if (true) {
            this.isShow = false
            return false
          }
          var reg = /{([\s\S]*?)}/g
          res.result.list.forEach((item) => {
            // console.log(item.content)
            if (item.content) {
              item.content_before = item.content
              item.content = item.content.replace(reg, function(str) {
                str = str.split('{')[1].split('}')[0]
                var strMap = _this.strMap
                // console.log(str, 'str')
                if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                  return strMap[0]
                } else {
                  return strMap[_this.biaoList.indexOf(str)]
                }
              })
            }
          })
          this.is_teacher = res.result.is_teacher
          res.result.list.forEach((item) => {
            item.list.forEach(item1 => {
              if (item1.content) {
                item1.content_before = item1.content
                item1.content = item1.content.replace(reg, function(str) {
                  str = str.split('{')[1].split('}')[0]
                  var strMap = _this.strMap
                  // console.log(str, 'str')
                  if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                    return strMap[0]
                  } else {
                    return strMap[_this.biaoList.indexOf(str)]
                  }
                })
              }
            })
          })
          if (this.page == 1) {
            this.QaList = res.result.list
          } else {
            this.QaList = this.QaList.concat(res.result.list)
          }
          this.QaCount = res.result.count
          this.total = res.result.count // 数据总条数
          this.retlen = res.result.list.length // 本次返回数据的长度
          if (this.retlen < this.limit) {
            this.finished = true // 数据加载完毕显示 没有更多了
            this.isShow = true
          }
          this.page++
          this.loading = false
        }
      })
    },
    // 我的提问
    onLoad1() {
      console.log(this.lesson_id)
      var params = {
        page: this.page1,
        limit: this.limit1,
        lesson_id: this.lesson_id
      }
      var _this = this

      Qame(params).then(res => {
        if (res.errNo === 0) {
          res.result.list.forEach(e => {
            this.$set(e, 'page', 1)
            this.$set(e, 'replyMsg', `展开${e.count - 1}条回复`)
          })
          this.subnum = res.result.unread
          if (!res.result.list.length && !this.myQaList.length) {
          // if (true) {
            this.isShow1 = false
            return false
          }
          var reg = /{([\s\S]*?)}/g
          res.result.list.forEach((item) => {
            if (item.content) {
              item.content_before = item.content
              item.content = item.content.replace(reg, function(str) {
                str = str.split('{')[1].split('}')[0]
                var strMap = _this.strMap
                // console.log(str, 'str')
                if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                  return strMap[0]
                } else {
                  return strMap[_this.biaoList.indexOf(str)]
                }
              })
            }
          })
          res.result.list.forEach((item) => {
            item.list.forEach(item1 => {
              if (item1.content) {
                item1.content_before = item1.content
                item1.content = item1.content.replace(reg, function(str) {
                  str = str.split('{')[1].split('}')[0]
                  var strMap = _this.strMap
                  // console.log(str, 'str')
                  if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                    return strMap[0]
                  } else {
                    return strMap[_this.biaoList.indexOf(str)]
                  }
                })
              }
            })
          })
          this.myQaList = this.myQaList.concat(res.result.list)
          this.myQaCount = res.result.count
          this.total1 = res.result.count // 数据总条数
          this.retlen1 = res.result.list.length // 本次返回数据的长度
          if (this.retlen1 < this.limit1) {
            this.finished1 = true // 数据加载完毕显示 没有更多了
            this.isShow1 = true
          }
          this.page1++
          this.loading1 = false
        }
      })
    },
    // 我的回答
    onLoad2() {
      console.log(this.lesson_id)
      var params = {
        page: this.page2,
        limit: this.limit2,
        lesson_id: this.lesson_id
      }
      var _this = this

      Qamyreply(params).then(res => {
        if (res.errNo === 0) {
          res.result.list.forEach(e => {
            this.$set(e, 'page', 1)
            this.$set(e, 'replyMsg', `展开${e.count - 1}条回复`)
          })
          if (!res.result.list.length && !this.replyQaList.length) {
          // if (true) {
            this.isShow2 = false
            return false
          }
          var reg = /{([\s\S]*?)}/g
          res.result.list.forEach((item) => {
            if (item.content) {
              item.content_before = item.content
              item.content = item.content.replace(reg, function(str) {
                str = str.split('{')[1].split('}')[0]
                var strMap = _this.strMap
                // console.log(str, 'str')
                if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                  return strMap[0]
                } else {
                  return strMap[_this.biaoList.indexOf(str)]
                }
              })
            }
          })
          res.result.list.forEach((item) => {
            item.list.forEach(item1 => {
              if (item1.content) {
                item1.content_before = item1.content
                item1.content = item1.content.replace(reg, function(str) {
                  str = str.split('{')[1].split('}')[0]
                  var strMap = _this.strMap
                  // console.log(str, 'str')
                  if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                    return strMap[0]
                  } else {
                    return strMap[_this.biaoList.indexOf(str)]
                  }
                })
              }
            })
          })
          this.replyQaList = this.replyQaList.concat(res.result.list)
          this.replyQaCount = res.result.count
          this.total2 = res.result.count // 数据总条数
          this.retlen2 = res.result.list.length // 本次返回数据的长度
          if (this.retlen2 < this.limit2) {
            this.finished2 = true // 数据加载完毕显示 没有更多了
            this.isShow2 = true
          }
          this.page2++
          this.loading2 = false
        }
      })
    },
    submit() {
      this.$router.push({
        path: '/SubmitQuestions',
        query: {
          lesson_id: this.lesson_id,
          active: this.active,
          lesson_name: this.lesson_name,
          is_buy: this.is_buy
        }
      })
    },
    goBack() {
      this.$router.go(-1)
      // this.$router.push({
      //   path: '/home',
      //   query: {
      //     lesson_id: this.lesson_id
      //   }
      // })
    },
    changeIndex(index, images) {
      ImagePreview({ images: images, startPosition: index })
    },
    checkedMyTab(index) {
      this.active = index
      console.log(index)
      document.documentElement.scrollTop = 0
      this.QaList = []
      this.myQaList = []
      this.replyQaList = []
      this.page2 = 1
      this.page1 = 1
      this.page = 1
      if (index == 0) {
        this.onLoad()
        this.loading = true
        this.finished = false
      }
      if (index == 1) {
        this.onLoad1()
        this.loading1 = true
        this.finished1 = false
      }
      if (index == 2) {
        this.onLoad2()
        this.loading2 = true
        this.finished2 = false
      }
    },
    styleChange() {
      this.$nextTick(() => {
        if (!this.isWeixin) {
          if (document.getElementsByClassName('mytab')[0]) {
            document.getElementsByClassName('mytab')[0].style.marginTop = '44px'
            document.getElementsByClassName('mytab')[0].style.position = 'fixed'
            document.getElementsByClassName('mytab')[0].style.top = '2px'
            document.getElementsByClassName('mytab')[0].style.zIndex = '999'
          }
          if (document.getElementsByClassName('activeDIV')[0]) {
            document.getElementsByClassName('activeDIV')[0].style.marginTop = '107PX'
            document.getElementsByClassName('activeDIV')[1].style.marginTop = '107PX'
            document.getElementsByClassName('activeDIV')[2].style.marginTop = '107PX'
          }
        } else {
          if (document.getElementsByClassName('wechatHead')[0]) {
            document.getElementsByClassName('wechatHead')[0].style.position = 'fixed'
            document.getElementsByClassName('wechatHead')[0].style.top = '0px'
            document.getElementsByClassName('wechatHead')[0].style.zIndex = '999'
          }
          if (document.getElementsByClassName('mytab')[0]) {
            document.getElementsByClassName('mytab')[0].style.position = 'fixed'
            document.getElementsByClassName('mytab')[0].style.top = '40px'
            document.getElementsByClassName('mytab')[0].style.zIndex = '999'
          }
          if (document.getElementsByClassName('activeDIV')[0]) {
            document.getElementsByClassName('activeDIV')[0].style.marginTop = '107PX'
            document.getElementsByClassName('activeDIV')[1].style.marginTop = '107PX'
            document.getElementsByClassName('activeDIV')[2].style.marginTop = '107PX'
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#here{
  position: absolute;
  top: -500px;
}
/deep/ .van-pull-refresh {
	height: calc(100vh - 100px) !important;
  overflow: auto !important;
}
/deep/ .van-list {
  height: auto !important;
}
.imgbackg{
width: 160px;
height: 160px;
background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
}
.replytest{
  font-weight: 600;
  font-size: 26px;
}
.avatars{
  position: relative;
}
.haveread{
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: #ee2e2e;
  position: absolute;
  right: -4px;
  top: -3px;
}
.popuptitle{
  text-align: center;
  padding-top: 30px;
  font-size: 30px;
  font-weight: 600;
}
.popupbox{
  width: 642px;
  height: 64px;
  background: #f4f4f4;
  margin: 0 auto;
  margin-top: 30px;
  color: #333;
  text-align: center;
  line-height: 66px;
  border-radius: 32px;
}
.popupboxred{
  background: #ee2e2e;
  color: #fff;
}
.bottomArrow{
  width: 17px;
  height: 17px;
  margin: 0 20px 0px 0;
}
.logo{
  width: 32px;
  height: 32px;
  margin: 0 0 0 30px;
}
.iptboxdiv{
  display: flex;
  align-items: center;
  p{
  padding: 0px 0 0 16px ;
color:#333;
  }
}
.wechatHead{
  margin: 0px 0 0 0 ;
  background: #fff;
  height: 90px;
  width: 100%;
  .iptbox{
  display: flex;
  justify-content: space-between;
background: #f4f4f4;
align-items: center;

border-radius: 38px;
 width: 690px;
  height: 64px;
  margin: 0 auto;
  }

}
.bluespan{
  color: #0091FF !important;
  font-size: 26px;
  font-weight: 600;

}
.redspan{
  color: #ee2e2e !important;
  font-size: 26px;
font-weight: 600;
}
.qacontent /deep/ img{
  width: 70px;
  position: relative;
  top: 20px;
}
.goTop{
    position: fixed;
    bottom: 120px;
    right: 40px;
    z-index: 1000;
    img{
        width: 120px;
        height: 120px;
        display: block;
        margin: 0px 0 0 0 ;
    }
}
.noIsBuy{
    padding: 120px 0 50px 0;
}
.moreImg{
    position: relative;
    .grayAdd{
        position: absolute;
        width: 160px;
        height: 160px;
        background: #000;
        opacity:0.7;
        p{
            font-size: 44px;
            color: #fff;
            line-height: 160px;
            text-align: center;
        }
    }
}
.replyImgs .moreImg:nth-child(1){
    margin-left: 0;
}
.replyImgs{
    margin: 12px 0 14px 0;
    width: 100%;
    display: flex;
    .moreImg{
        margin: 0 0 0 14px;
    }
    img{
        width: 160px;
        height: 160px;
    }
}
.div_sq{
  margin-left: 188px;
  color: #999999;
  font-size: 26px;
}
.openReply{
    display: flex;
    margin-top: 20px;
    img{
        width: 20px;
        height: 14px;
        margin: 12px 0 0 15px;
    }
}
.reply{
  display: flex;
  width: 100%;
  margin: 30px 0 0 0;
  .replyQaDivleft img{
    width: 52px;
    height: 52px;
    border-radius: 50%;
    margin: 0 0 0 120px;
  }
  .replyQaDivright{
    margin: 0 0 0 16px;
    .replyqaname{
      padding: 4px 0 0 0;
      color: #999;
      span{
        font-weight: 600;
        font-size: 26px;
      }
    }
    .replyqacontent{
      color: #333;
      padding: 12px 0 0 0;
      width: 524px;
      word-wrap: break-word;
      font-size: 28px;
    }
    .replyqacontent /deep/ img{
      width: 36px;
  position: relative;
  top: 9px;
    }
    .replyqatime{
      color: #999;
      padding: 0px 0 0 0;
      font-size: 26px;
      span{
          padding: 0 0 0 30px;
          font-weight: 600;
      }
    }
    .replyqareply{
      color: #999;
      padding: 12px 0 0 0;
    }
  }
}
.QaDiv{
  display: flex;
  width: 100%;
  padding: 40px 0 0 0;
  .QaDivleft img{
    width: 72px;
    height: 72px;
    border-radius: 50%;
    margin: 0 0 0 30px;
  }
  .QaDivright{
    margin: 0 0 0 16px;
    .qaname{
      color: #999;
      font-weight: 600;
      font-size: 26px;
    }
    .qalesson{
      color: #999;
      padding: 10px 0 0 0;
      font-size: 26px;

    }
    .qacontent{
      color: #333;
      word-break: break-all;
      padding: 12px 0 0 0;
      width: 588px;
      font-size: 28px;

    }
    .qatime{
      color: #999;
      padding: 0px 0 0 0;
      font-size: 26px;
      margin-right: 12px;
      span{
          padding: 0 0 0 30px;
          font-weight: 600;
      }
    }
    .qareply{
      color: #999;
      padding: 12px 0 0 0;
    }
  }
}
.tabp{
    position: relative;
}
.moreNum{
    display: inline-block;
    min-width: 18px;
    min-height: 28px;
    background: #ee2e2e;
    line-height: 28px !important;
    font-size: 20px !important;
    color: #fff !important;
    border-radius: 20px;
    padding: 2px 13px 0 10px;
    text-align: center;
    position: absolute;
    top: 10px;
}
.redBottomspan{
    color: #ee2e2e !important;
}
.mytab_content {
  width: 75%;
  height: 90px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  line-height: 90px;
  .redBottom {
    min-width: 130px;
    border-bottom: 5px solid #ee2e2e;
    text-align: center;
    font-weight: 600;
  }
  p {
    min-width: 130px;
    text-align: center;
    span {
      font-size: 30px;
      color: #999;
    }
  }
}
.qa_main{
  position: absolute;
  width: 100%;
  // top:90px;
}
.mytab {
  width: 100%;
  height: 90px;
  border-bottom: 2px solid #dfdfdf;
  background: #fff;
  position:fixed;
  top: 92px;
  z-index:1;

}
.head {
  width: 100%;
  height: 90px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  border-bottom: 1px solid #eee;
  z-index: 1;
}
.img_arrow {
  width: 50px;
  height: 55px;
  padding-left: 30px;
  padding-top: 9px;
}
.my_title {
  font-weight: 500;
  color: #333;
  font-size: 36px;
  /* font-weight: 600; */
  letter-spacing: 2px;
  padding-right: 70px;
}
.nodatas {
  margin-top: 240px;
  text-align: center;
  p {
    color: #333;
    font-size: 26px;
    margin-top: 20px;
  }
}replyQaDivleft
.tabmsg{
  font-size: 30px !important;
}
// .qa_main{
//   padding-top:90px;
// }
.tablist{
  margin-top:200px;
}
</style>
